import {NgModule} from '@angular/core';
import {SharedModule} from '@helpers/modules/shared.module';
import {ConclusionRoutingModule} from './conclusion-routing.module';
import {ConclusionViewComponent} from './conclusion-view/conclusion-view.component';
import {ConclusionFormComponent} from './conclusion-form/conclusion-form.component';
import {ConclusionEquipmentListComponent} from './components/conclusion-equipment-list/conclusion-equipment-list.component';
import {EquipmentCardModule} from '@modules/equipment-card/equipment-card.module';
import {ConclusionEquipmentResolver} from './services/conclusion-equipment.resolver';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {ConclusionFormSignersComponent} from './components/conclusion-form-signers/conclusion-form-signers.component';
import {ConclusionSignersStructureResolver} from './services/conclusion-signers-structure.resolver';
import {ConclusionSignersSpecialistsListResolver} from './services/conclusion-signers-specialists-list.resolver';
import {ConclusionTechnicalCardResolver} from './services/conclusion-technical-card.resolver';
import {ConclusionResolver} from './services/conclusion.resolver';
import {ConclusionDeviceElementResolver} from './services/conclusion-device-element.resolver';
import {ConclusionElementPreviewComponent} from './components/conclusion-element-preview/conclusion-element-preview.component';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {ConclusionBlankResolver} from './services/conclusion-blank.resolver';
import {ModalModule} from '@components/modal/modal.module';
import {DynamicFieldsModule} from '@subforms/dynamic-fields/dynamic-fields.module';
/* tslint:disable:max-line-length */
import {ConclusionFormAttestationDocumentsComponent} from './components/conclusion-form-attestation-documents/conclusion-form-attestation-documents.component';
import {ConclusionFormInspectionParamsComponent} from './components/conclusion-form-inspection-params/conclusion-form-inspection-params.component';
import {ConclusionFormInspectionParamsFormModalComponent} from './components/conclusion-form-inspection-params-form-modal/conclusion-form-inspection-params-form-modal.component';
import {ConclusionFormInspectionItemComponent} from './components/conclusion-form-inspection-item/conclusion-form-inspection-item.component';
import {ConclusionFormInspectionListComponent} from './components/conclusion-form-inspection-list/conclusion-form-inspection-list.component';
/* tslint:enable:max-line-length */
import {ConclusionDefectFormComponent} from './components/conclusion-defect-form/conclusion-defect-form.component';
import {ConclusionDefectItemComponent} from './components/conclusion-defect-item/conclusion-defect-item.component';
import {PipesModule} from '@pipes/pipes.module';
import {ConclusionComponentsModule} from '@modules/conclusion/conclusion-components.module';
import { ConclusionListComponent } from './conclusion-list/conclusion-list.component';
import { ConclusionListFiltersPanelComponent } from './components/conclusion-list-filters-panel/conclusion-list-filters-panel.component';
import {PagingControlModule} from '@components/paging-control/paging-control.module';
import {FilteredConclusionResolver} from './services/conclusion-pages/filtered-conclusion.resolver';
import {ConclusionPagesService} from './services/conclusion-pages/conclusion-pages.service';
import {ConclusionPagesResetOnDeactivateService} from './services/conclusion-pages/conclusion-pages-reset-on-deactivate.service';
import {Lab365CommonModule} from '@lab365/common';
import {ConclusionStatusSelectValuesListResolver} from './services/filter-params/conclusion-status-select-values-list.resolver';
import {TechnicalDeviceSelectValuesListResolver} from './services/filter-params/technical-device-select-values-list.resolver';
import {WorkingObjectsSelectValuesListResolver} from './services/filter-params/working-objects-select-values-list.resolver';
import {IndustryMethodsSelectValuesListResolver} from './services/filter-params/industry-methods-select-values-list.resolver';
import {IconsModule} from '@lab365/icons';
import {ConclusionListItemComponent} from './components/conclusion-list-item/conclusion-list-item.component';

@NgModule({
    imports: [
        SharedModule,
        ConclusionRoutingModule,
        EquipmentCardModule,
        DirectivesModule,
        FilesUploaderModule,
        ModalModule,
        DynamicFieldsModule,
        PipesModule,
        ConclusionComponentsModule,
        PagingControlModule,
        Lab365CommonModule,
        IconsModule,
    ],
    exports: [],
    declarations: [
        ConclusionViewComponent,
        ConclusionFormComponent,
        ConclusionEquipmentListComponent,
        ConclusionFormSignersComponent,
        ConclusionFormAttestationDocumentsComponent,
        ConclusionFormInspectionListComponent,
        ConclusionElementPreviewComponent,
        ConclusionFormInspectionParamsComponent,
        ConclusionFormInspectionParamsFormModalComponent,
        ConclusionFormInspectionItemComponent,
        ConclusionDefectFormComponent,
        ConclusionDefectItemComponent,
        ConclusionListComponent,
        ConclusionListFiltersPanelComponent,
        ConclusionListItemComponent,
    ],
    providers: [
        ConclusionResolver,
        ConclusionBlankResolver,
        ConclusionEquipmentResolver,
        ConclusionSignersSpecialistsListResolver,
        ConclusionSignersStructureResolver,
        ConclusionTechnicalCardResolver,
        ConclusionDeviceElementResolver,

        FilteredConclusionResolver,
        ConclusionPagesService,
        ConclusionPagesResetOnDeactivateService,

        ConclusionStatusSelectValuesListResolver,
        TechnicalDeviceSelectValuesListResolver,
        WorkingObjectsSelectValuesListResolver,
        IndustryMethodsSelectValuesListResolver,
    ],
    entryComponents: [
        ConclusionFormInspectionParamsFormModalComponent,
        ConclusionDefectFormComponent,
    ]
})
export class ConclusionModule {
}
